import React from 'react'

const WorkshopMaster = () => {
  return (
    <div>WorkshopMaster</div>
  )
}

export default WorkshopMaster